<template>
  <b-container fluid class="layout-wide py-5">
    <h2 class="font-weight-bold mb-4"><span class="text-primary">거래처</span> 관리</h2>

    <b-card class="border-0 shadow-sm mb-4 rounded-lg">
      <b-row align-v="end">
        <b-col md="4">
          <b-form-group label="거래처명" label-class="small font-weight-bold text-muted">
            <b-form-input v-model="form.name" placeholder="거래처 이름을 입력하세요"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="비고" label-class="small font-weight-bold text-muted">
            <b-form-input v-model="form.memo" placeholder="메모 사항"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="2" class="mb-3 d-flex align-items-center justify-content-center">
          <b-form-checkbox v-model="form.isActive" switch size="lg">
            <span class="small font-weight-bold" :class="form.isActive ? 'text-primary' : 'text-danger'">
              {{ form.isActive ? '활성' : '비활성' }}
            </span>
          </b-form-checkbox>
        </b-col>
        <b-col md="2" class="mb-3">
          <b-button v-if="form.id" variant="warning" block @click="save" class="rounded-pill font-weight-bold">수정</b-button>
          <b-button v-else variant="primary" block @click="save" class="rounded-pill font-weight-bold">추가</b-button>
        </b-col>
      </b-row>
    </b-card>

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="text-muted small">총 <b class="text-primary">{{ customers.length }}</b>건의 거래처</div>
      <b-form-checkbox v-model="includeInactive" @change="load" name="check-button" switch>
        <span class="small font-weight-bold">활성화 항목</span>
      </b-form-checkbox>
    </div>

    <b-table
        :items="customers"
        :fields="fields"
        head-variant="light"
        class="bg-white shadow-sm rounded-lg overflow-hidden"
        :tbody-tr-class="rowClass"
    >
      <template #cell(isActive)="data">
        <b-badge :variant="data.value ? 'success' : 'secondary'" pill class="px-3">
          {{ data.value ? '활성' : '비활성' }}
        </b-badge>
      </template>

      <template #cell(updatedAt)="data">
        {{ formatDateTime(data.value) }}
      </template>

      <template #cell(actions)="data">
        <b-button size="sm" variant="outline-primary" @click="edit(data.item)" class="mr-1 rounded-pill px-3">수정</b-button>
        <b-button size="sm" variant="outline-danger" @click="remove(data.item.id)" class="rounded-pill px-3">삭제</b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>

export default {
  data() {
    return {
      includeInactive: true, // 비활성화 포함 여부
      form: {
        id: null,
        name: '',
        memo: '',
        isActive: true // 기본값 활성
      },
      customers: [],
      fields: [
        {key:'isActive', label:'상태', thClass: 'text-center', tdClass: 'text-center align-middle'},
        {key:'name', label:'거래처명', thClass: 'text-center', tdClass: 'text-center align-middle'},
        {key:'memo', label:'비고', thClass: 'text-center', tdClass: 'text-center align-middle'},
        {key:'updatedAt', label:'최근 수정일', thClass: 'text-center', tdClass: 'text-center align-middle'},
        {key:'actions', label:'관리', thClass: 'text-center', tdClass: 'text-center align-middle'}
      ]
    }
  },
  created() { this.load(); },
  methods: {
    // 행 스타일 지정 (비활성 항목은 흐리게)
    rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (!item.isActive) return 'text-muted bg-light-opacity';
    },
    // 날짜 변환 함수
    formatDateTime(dateStr) {
      if (!dateStr) return '-';
      // T를 공백으로 바꾸고, 초 단위(:00)가 필요 없다면 .substring(0, 16) 자릅니다.
      // 예: 2025-12-23 14:07:00
      return dateStr.replace('T', ' ').substring(0, 19);
    },
    // 수정 버튼 클릭 시 폼에 데이터 세팅
    edit(item) {
      this.form = { ...item };
    },
    async load() {
      try {
        const res = await this.$axios.get('/api/customers', {
          params: {
            userId: localStorage.getItem('userId'),
            includeInactive: this.includeInactive // 서버에 포함 여부 전달
          }
        })
        this.customers = res.data.data;
      } catch (err) {
        console.error(err);
      }
    },
    async save() {
      if(!this.form.name) return alert('거래처명을 입력해주세요.');
      try {
        this.form.userId = localStorage.getItem('userId');
        const res = await this.$axios.post('/api/customer/save', this.form);
        if (res.status === 200) {
          alert('저장되었습니다.');
          this.resetForm();
          this.load();
        }
      } catch (err) {
        console.error(err);
      }
    },
    resetForm() {
      this.form = { id: null, name: '', memo: '', isActive: true };
    },
    async remove(id) {
      if(!confirm('정말 삭제하시겠습니까?')) return;
      try {
        await this.$axios.delete(`/api/customer/${id}`);
        this.load();
      } catch (err) {
        console.error(err);
      }
    }
  }
}
</script>
